<div class="modal-container">
  <h1 mat-dialog-title>Thank-You</h1>
  <div mat-dialog-content class="modal-container-input">
    <p>We have received your request, and an admin will look at it shortly</p>
  </div>
  <div mat-dialog-actions class="actions">
    <button mat-stroked-button (click)="onNoClick()">Ok</button>
  </div>
</div>
